import {takeLatest, call} from "redux-saga/effects";
import * as actions from "../action.constants";
import {
  resetPasswordAsync,
  verifyEmailAsync,
  verifyTokenAsync,
} from "../AsyncActions/login.async";

function* verifyEmail(action = {}) {
  const {payload = {}, callback = () => {}} = action;
  try {
    const response = yield call(verifyEmailAsync, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* verifyToken(action = {}) {
  const {payload = {}, callback = () => {}} = action;
  try {
    const response = yield call(verifyTokenAsync, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* resetPassword(action = {}) {
  const {payload = {}, callback = () => {}} = action;
  try {
    const response = yield call(resetPasswordAsync, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

export function* groupSaga() {
  yield takeLatest(actions.VERIFY_EMAIL, verifyEmail);
  yield takeLatest(actions.VERIFY_TOKEN, verifyToken);
  yield takeLatest(actions.RESET_PASSWORD, resetPassword);
}
